// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  API_BASE: 'https://apiserver.gestdocout360.es/',
  API_DOMAIN: 'apiserver.gestdocout360.es',
  SESSION_TTL: 1800,
  MINUTES_RELOAD_NOTIFICATIONS: 2,
  MAX_FILESIZE: 5 * 1024 * 1024,
  MAINTENANCE: false,
  ESTIMATED_MAINTENANCE_FINISH_DATE: undefined // ISO-8601 DATE
};
